import type { FeedbackCategory, FeedbackStatus } from "./types";

export const feedbackCategoryLabels: Record<FeedbackCategory, string> = {
  BUG: "Hata / bug",
  SHIFT_CALENDAR: "Yanlış vardiya veya takvim",
  LEAVE_REQUEST: "İzin / talep sorunu",
  DESIGN: "Tasarım / görünüm",
  SUGGESTION: "Öneri",
  OTHER: "Diğer",
};

export const feedbackStatusLabels: Record<FeedbackStatus, string> = {
  RECEIVED: "Alındı",
  IN_REVIEW: "İnceleniyor",
  PLANNED: "Planlandı",
  IN_PROGRESS: "Çalışılıyor",
  WAITING_USER: "Yanıtınız bekleniyor",
  RESOLVED: "Çözüldü",
  CLOSED: "Kapatıldı",
};
